import { useTranslation } from "react-i18next"
import { Package } from "lucide-react"
import { useFeatureFlagEnabled } from "posthog-js/react"
import BaseSidebarButton from "./BaseSidebarButton"
import { TAB_TYPES } from "@/reducers/tabsSlice"
import { PackageIconActive } from "@/components/icons/PackageIcon"

const DeliveryOrdersSidebarButton = ({ className }: { className?: string }) => {
  const { t } = useTranslation()
  const isEnabled = Boolean(useFeatureFlagEnabled("delivery-orders-ui"))
  if (!isEnabled) return null

  return (
    <BaseSidebarButton
      tabName={TAB_TYPES.DELIVERY_ORDERS}
      icon={Package}
      activeIcon={PackageIconActive}
      tooltipText={t("app.sidebar.deliveryOrders")}
      className={className}
    />
  )
}

export default DeliveryOrdersSidebarButton
